import { render, staticRenderFns } from "./OrderUserTab.vue?vue&type=template&id=98dbdcac&scoped=true"
import script from "./OrderUserTab.vue?vue&type=script&lang=ts"
export * from "./OrderUserTab.vue?vue&type=script&lang=ts"
import style0 from "./OrderUserTab.vue?vue&type=style&index=0&id=98dbdcac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dbdcac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98dbdcac')) {
      api.createRecord('98dbdcac', component.options)
    } else {
      api.reload('98dbdcac', component.options)
    }
    module.hot.accept("./OrderUserTab.vue?vue&type=template&id=98dbdcac&scoped=true", function () {
      api.rerender('98dbdcac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/OrderUserTab.vue"
export default component.exports